import { MenuIcon, XIcon } from "@heroicons/react/solid";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import LogoBlack from "../../assets/logo.png";
import IconButton from "./IconButton";

interface Props {
  page: string;
}

interface Navigation {
  name: string;
  href: string;
}

const navigation: Navigation[] = [
  {
    name: "Ranking",
    href: "/ranking",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

class Header extends Component<Props> {
  state = {
    mobileMenu: false,
  };

  handleOpenMobileMenu = () => {
    this.setState({
      mobileMenu: !this.state.mobileMenu,
    });
  };

  renderLogo = () => {
    return (
      <Link to="/">
        <div className="flex flex-row items-center justify-center">
          <img className="h-12 w-auto sm:h-10" src={LogoBlack} alt="UBI App" />
          <span className="text-lg font-bold tracking-tight ml-1">UBI App</span>
        </div>
      </Link>
    );
  };

  renderHeaderLink = (type: string, isLaptop: boolean) => {
    let linkNav = "";
    let linkTitle = "";
    switch (type) {
      case "signIn":
        linkTitle = "Sign In";
        linkNav = "/auth/signIn";
        break;
    }

    if (linkNav && linkTitle) {
      if (isLaptop) {
        return (
          <Link to={linkNav}>
            <span className="ml-8 whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900">
              {linkTitle}
            </span>
          </Link>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="relative bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <span className="sr-only">UBI App</span>
              {this.renderLogo()}

              <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={classNames(
                      this.props.page === item.name
                        ? "border-orange-500 text-gray-900"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                      "inline-flex items-center px-1 pt-1 border-b-2 text-base font-medium"
                    )}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            <div className="-mr-2 -my-2 md:hidden">
              <IconButton
                icon={<MenuIcon className="h-5 w-5 text-gray-400" />}
                onClick={this.handleOpenMobileMenu}
                className="rounded-md"
              />
            </div>
          </div>
        </div>

        {this.state.mobileMenu && (
          <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-40">
            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <div className="pt-5 pb-6 px-5">
                <div className="flex items-center justify-between">
                  <div>{this.renderLogo()}</div>
                  <div className="-mr-2">
                    <IconButton
                      icon={<XIcon className="h-5 w-5 text-orange-600" />}
                      onClick={this.handleOpenMobileMenu}
                    />
                  </div>
                </div>
              </div>
              <div className="py-6 px-5 space-y-6">
                {navigation.map((eachNavigation, key) => (
                  <div className="grid grid-cols-2 gap-y-4 gap-x-8" key={key}>
                    <Link
                      to={eachNavigation.href}
                      className="text-base font-medium text-gray-900 hover:text-gray-700"
                    >
                      {eachNavigation.name}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Header;
